import { fetcher } from '../../../components/Hooks/useListActions';
import { SalesOpportunityConversion } from '../../../modules/sales-opportunity/salesOpportunity.types';
import { restApi } from '../../api';
import { GetSalesOpportunityConversions } from './orderbook.types';

const SALES_OPPORTUNITIES_PATH = 'sales-opportunities';

export const getSalesOpportunities = () => fetcher(SALES_OPPORTUNITIES_PATH);

export const getSalesOpportunitiesCategories = (salesOpportunityId: string) =>
  fetcher(`${SALES_OPPORTUNITIES_PATH}/${salesOpportunityId}/categories-with-conversions`);

export const getSalesOpportunityConversion = (params: GetSalesOpportunityConversions) =>
  restApi.get<SalesOpportunityConversion[]>(
    `/${SALES_OPPORTUNITIES_PATH}/conversion?${params?.urlParams || ''}`,
  );
